<template>
	<div class="jurisdiction">
		<div style="display: flex; align-items: center;  justify-content: space-between; margin-bottom: 20px;">
			<div style="color: #515A6E; font-weight: bold;">权限</div>
			<Button type="primary"  @click="saveOkClick">确认保存</Button>
		</div>
		<div style="display: flex; justify-content: space-between; border: 1px solid #EEEEEE; padding: 20px;">
			<div class="page">
				<div style="color: #515A6E; font-weight: bold;">页面权限</div>
				<div v-for="(item,index) in permission" :key='index' style="margin-top:35px">
					<div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
						<Checkbox v-model='item.checked' @on-change="changBoxOne(item)">{{item.name}}</Checkbox>
					</div>
					<div style="display: flex;">
						<div style="display: flex; flex-direction: column;">
							<div style="padding: 5px 0; padding-left: 10px"  v-for="(check,indexTwo) in item.children">
								<Checkbox style=" height: 30px;line-height: 30px; width: 150px"
										  :key='indexTwo' v-model='check.checked' @on-change="changBoxTwo(item,check)">
									{{check.name}}
								</Checkbox>
								<div style="padding-left: 20px">
									<Checkbox v-for="(checkList,indexThree) in check.ext_info" :key='indexThree'
											  @on-change="checkAllGroupChange(item, check, checkList)" v-model="checkList.checked">
										<span>{{checkList.name}}</span>
									</Checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--            <div class="data_jurisdiction">-->
			<!--                <div style="color: #515A6E; font-weight: bold;">数据权限</div>-->
			<!--                <RadioGroup v-model="dataJurisdiction">-->
			<!--                    <div style="display: flex; flex-direction: column; justify-content: space-around; height: 150px;">-->
			<!--                        <Radio label="全部"></Radio>-->
			<!--                        <Radio label="本部门及下属部门"></Radio>-->
			<!--                        <Radio label="本部门"></Radio>-->
			<!--                        <Radio label="自己"></Radio>-->
			<!--                    </div>-->
			<!--                </RadioGroup>-->
			<!--            </div>-->
		</div>
	</div>
</template>

<script>

	import {mapGetters} from "vuex";

	import {
		getPermission,savePermission
	} from '@/api/user'
	export default {
		name: "Jurisdiction",
		props: ['activeId'],
		data() {
			return {
				// 数据权限绑定
				dataJurisdiction: '自己',
				checkAllGroup: [],
				permission: [],
			}
		},
		watch: {
			activeId() {
				this.getPermission();
			}
		},
		mounted() {
			if(this.activeId !=0){
				this.getPermission();
			}
			
		},
		computed:{
			...mapGetters(['userInfo', 'token'])
		},
		methods: {
			async getPermission() {
				let that = this;
				let data = {token: this.token};
				data.id = that.activeId;
				let res = await getPermission(that, data);

				if (res.code == 1) {
					that.permission = res.data.list;
				}
			},
			//确认保存按钮
			saveOkClick() {
				let that = this;
				let data = {token: this.token}
				data.id = that.activeId;
				data.permission = this.permission;
				this.throttle(async function () {
					let res = await savePermission(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
					}
				}, 2000)
			},
			// 第一级
			changBoxOne(item) {
				if (item.checked == false) {
					for (let i = 0; i < item.children.length; i++) {
						item.children[i].checked = false
						for (let j = 0; j < item.children[i].ext_info.length; j++) {
							item.children[i].ext_info[j].checked = false
						}
					}
				} else {
					for (let i = 0; i < item.children.length; i++) {
						item.children[i].checked = true
						for (let j = 0; j < item.children[i].ext_info.length; j++) {
							item.children[i].ext_info[j].checked = true
						}
					}
				}
			},
			// 第二级
			changBoxTwo(father, item) {
				if (item.checked == false) {
					for (let i = 0; i < item.ext_info.length; i++) {
						item.ext_info[i].checked = false
					}
				} else {
					for (let i = 0; i < item.ext_info.length; i++) {
						item.ext_info[i].checked = true
					}
				}
				let checkNum = 0;
				for (let i = 0;i < father.children.length; i++) {
					if (father.children[i].checked == true) {
						checkNum++;
					}
				}
				if (checkNum >= 1) {
					father.checked = true;
				} else {
					father.checked = false;
				}
			},
			// 第三级
			checkAllGroupChange(grandFather, father, item) {
				let checkNum = 0;
				for (let i = 0;i < father.ext_info.length; i++) {
					if (father.ext_info[i].checked == true) {
						checkNum++;
					}
				}
				if (checkNum >= 1) {
					father.checked = true;
				} else {
					// father.checked = false;
				}
				// checkNum = 0;
				// for (let i = 0;i < grandFather.children.length; i++) {
				// 	if (grandFather.children[i].checked == true) {
				// 		checkNum++;
				// 	}
				// }
				// if (checkNum >= 1) {
				// 	grandFather.checked = true;
				// } else {
				// 	grandFather.checked = false;
				// }
			},
			arrayColumn(arr, key) {
				let ret = [];
				arr.forEach(function (row) {
					ret.push(row.key);
				})
				return ret;
			}
		}
	}
</script>

<style scoped lang="less">
	.jurisdiction {
		margin-left: 10px;
		width: 900px;
		background-color: #FFFFFF;
		padding: 20px;
	}
</style>
